import React, { memo } from 'react';
import { shallow } from 'zustand/shallow';
import { CadastroRangeDePrecosContent } from '../CadastroRangeDePrecosContent';
import { ContentUpload } from '../../../SetupInfoPanelAnaliseDeCobertura/components/ContentUpload';
import { ModalUploadAderenciaSetup } from '../../components/ModalUploadAderenciaSetup';
import { UploadTableAderencia } from '../UploadTableAderencia';
import { useSetupAderenciaDePrecosStore } from '../../SetupAderenciaDePrecos.store';
import * as service from '../../services';
import styles from './CadastroRangeDePrecos.module.scss';
import { useUploadAderenciaFiles } from '../../hooks/useUploadAderenciaFiles';
import { useGetAderenciaUploadedList } from '../../hooks/useGetAderenciaUploadedList';

export const CadastroRangeDePrecos = () => {
  const {
    openModalAderenciaProductUpload,
    aderenciaProductUploadResponse,
    aderenciaProductUploadError,
    aderenciaProdutoTableData,
    setAderenciaClickProsseguirProduto,
    setSetupAnaliseDeAderenciaState,
    setAderenciaProdutoTableData,
    setAderenciaOpenModalProduto,
  } = useSetupAderenciaDePrecosStore();

  const { uploadProgress, validateUploadProductFile } = useUploadAderenciaFiles();

  useGetAderenciaUploadedList();

  const handleDownloadProductUploadErrors = async () => {
    const resp = await service.downloadAderenciaUploadedErrors(aderenciaProductUploadResponse?.uploadId);
    if (resp.status === 200) {
      setSetupAnaliseDeAderenciaState('openModalAderenciaProductUpload', false);
    }
  };

  const handleDownloadUploadedProducts = async (id: string, name: string) => {
    await service.downloadAderenciaUploadedItem(id, name);
  };

  const handlClickOpenModalUpload = () => {
    setAderenciaOpenModalProduto();
  };

  const handleClickCloseModalUpload = () => {
    setAderenciaProdutoTableData();
    setSetupAnaliseDeAderenciaState('openModalAderenciaProductUpload', false);
  };

  const handleClickProsseguir = () => {
    setAderenciaClickProsseguirProduto();
  };

  return (
    <div className={styles.container}>
      <CadastroRangeDePrecosContent onClickDownloadModel={() => service.downloadAderenciaSetupTemplate()} />
      <ContentUpload
        error={aderenciaProductUploadError}
        tableData={aderenciaProdutoTableData}
        uploadBoxTitle="Enviar produtos via arquivo"
        uploadBoxSubtitle="Suba a sua lista de produtos selecionados para a análise através de um arquivo .xlsx"
        onClickOpenModalUpload={handlClickOpenModalUpload}
        table={<UploadTableAderencia data={aderenciaProdutoTableData} onClickDownloadFile={handleDownloadUploadedProducts} />}
      />
      <ModalUploadAderenciaSetup
        type="RANGE_PRECOS"
        show={openModalAderenciaProductUpload}
        onClickDownloadModel={() => service.downloadAderenciaSetupTemplate()}
        invalidItems={aderenciaProductUploadResponse?.invalidos}
        uploadProgress={uploadProgress}
        onFileSelect={validateUploadProductFile}
        onHide={handleClickProsseguir}
        onClickCloseAndReset={handleClickCloseModalUpload}
        onClickDownloadErrors={handleDownloadProductUploadErrors}
      />
    </div>
  );
};
